
import { NavLink, useLocation } from "react-router-dom"
import styled from "styled-components"

const Container = styled.div`
    position: absolute !important;
    top: ${({isEnd})=> !isEnd && 0};
    bottom: ${({isEnd})=> isEnd && "-50px"};
    left: 268px;
    width: 300px;
    height: auto;
    max-height: 600px;
    overflow: auto;
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    -webkit-box-shadow: 5px 1px 22px -2px rgba(0,0,0,0.6); 
    box-shadow: 5px 1px 22px -2px rgba(0,0,0,0.6);
    z-index:25 !important;
    

    &::-webkit-scrollbar {
          width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #9e9b9b;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

    .navlink{
        width: 100% !important;
        color: ${({ theme }) => theme.mainTextColor};
        
        span{
            padding-left: 10px;
        }

        &:hover{
            border-radius: 10px;
            background-color: ${({theme})=> theme.secondaryBgColor};
        }
    }
    
    .active{
        color: var(--color-main);

    }

`

const NavbarSubLinksContainer = ({subLinks,isEnd,setHoveredItem, parentId}) => {

    const location = useLocation().pathname

  return (
    <Container isEnd={isEnd}>
        {subLinks.map((item)=> (
            <NavLink to={item.slug} key={item.id} state={{ subLinks}} onClick={()=>setHoveredItem(null)} className={({isActive})=> isActive ? "active navlink": "navlink"}><span>{item.description}</span></NavLink>
        ))}
    </Container>
  )
}

export default NavbarSubLinksContainer